import styled from "styled-components";

export const ShrinkHeader = styled.th`
  width: 1%;
`;
